// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2024 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

export const REPORT_UPPERCASE = "RECORD";
export const REPORTS_UPPERCASE = "RECORDS";

export const REPORT_CAPITALIZED = "Record";
export const REPORTS_CAPITALIZED = "Records";
export const REPORTING_CAPITALIZED = "Data Sharing";
export const REPORTED_CAPITALIZED = "Shared";
export const REPORTING_PERIOD_CAPITALIZED = "Recording Period";

export const REPORT_LOWERCASE = "record";
export const REPORTS_LOWERCASE = "records";
export const REPORTS_LOWERCASE2 = "monthly or annual records";
export const REPORTING_LOWERCASE = "sharing";
export const REPORTED_LOWERCASE = "shared";
export const REPORT_VERB_LOWERCASE = "share";
export const REPORT_VERB_LOWERCASE2 = "enter";
export const REPORTING_PERIOD_LOWERCASE = "time period";

export const SYSTEM_LOWERCASE = "sector";
export const SYSTEMS_LOWERCASE = "sectors";
export const SYSTEM_UPPERCASE = "SECTOR";
export const SYSTEMS_UPPERCASE = "SECTORS";
export const SYSTEM_CAPITALIZED = "Sector";
export const SYSTEMS_CAPITALIZED = "Sectors";
